import React from 'react';
import { Receipt, TrendingUp, TrendingDown, Clock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { formatCurrency } from './utils';

export const KPICards = ({ resumenCxC, facturasPendientes }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    <Card data-testid="kpi-total-por-cobrar">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium text-muted-foreground">Total por Cobrar</CardTitle>
          <Receipt className="h-4 w-4 text-muted-foreground" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl md:text-3xl font-display font-700 text-foreground">
          {formatCurrency(resumenCxC.total_por_cobrar)}
        </div>
        <p className="text-xs text-muted-foreground mt-1">
          {resumenCxC.num_facturas_pendientes} factura(s) pendiente(s)
        </p>
      </CardContent>
    </Card>

    <Card data-testid="kpi-vencido" className="border-red-200">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium text-muted-foreground">Vencido</CardTitle>
          <TrendingDown className="h-4 w-4 text-red-600" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl md:text-3xl font-display font-700 text-red-600">
          {formatCurrency(resumenCxC.total_vencido)}
        </div>
        <p className="text-xs text-muted-foreground mt-1">Requiere atención inmediata</p>
      </CardContent>
    </Card>

    <Card data-testid="kpi-por-vencer" className="border-yellow-200">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium text-muted-foreground">Por Vencer</CardTitle>
          <Clock className="h-4 w-4 text-yellow-600" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl md:text-3xl font-display font-700 text-yellow-600">
          {formatCurrency(resumenCxC.total_por_vencer)}
        </div>
        <p className="text-xs text-muted-foreground mt-1">Dentro de plazo</p>
      </CardContent>
    </Card>

    <Card data-testid="kpi-cobros-parciales">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium text-muted-foreground">Cobros Parciales</CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl md:text-3xl font-display font-700 text-foreground">
          {facturasPendientes.filter((f) => f.estado_pago === 'Parcial').length}
        </div>
        <p className="text-xs text-muted-foreground mt-1">Facturas con pagos parciales</p>
      </CardContent>
    </Card>
  </div>
);
